export const filterProductsData = [
  {
    city: 'Fort Chloetown',
    country: 'Paraguay',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/7.webp',
    rating: 2.87,
    ratingCount: 657,
    hostname: 'Zion',
    features: ['2 Balcony', '3 Baths'],
    price: {
      original: '$515',
      sale: '$465',
    },
    tag: 'Superhost',
  },
  {
    city: 'West Claude',
    country: 'Ethiopia',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/1.webp',
    rating: 1.85,
    ratingCount: 749,
    hostname: 'Tyreek',
    features: ['1 Balcony', '2 Beds', '4 Baths'],
    price: {
      original: '$682',
      sale: '$414',
    },
    tag: 'Plus',
  },
  {
    city: 'Jamalboro',
    country: "Lao People's Democratic Republic",
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/4.webp',
    rating: 1.92,
    ratingCount: 746,
    hostname: 'Mikel',
    features: ['3 Balcony', '5 Beds'],
    price: {
      original: '$636',
      sale: '$253',
    },
    tag: 'Premium',
  },
  {
    city: 'Conroe',
    country: 'Namibia',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/19.webp',
    rating: 2.07,
    ratingCount: 474,
    hostname: 'Dee',
    features: ['2 Baths', '3 Beds', '2 Balcony'],
    price: {
      original: '$509',
      sale: '$354',
    },
    tag: 'Plus',
  },
  {
    city: 'North Houston',
    country: 'Suriname',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/5.webp',
    rating: 4.34,
    ratingCount: 890,
    hostname: 'Christopher',
    features: ['4 Baths', '5 Beds'],
    price: {
      original: '$523',
      sale: '$424',
    },
    tag: 'Superhost',
  },
  {
    city: 'South Lamont',
    country: 'Iceland',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/20.webp',
    rating: 3.18,
    ratingCount: 660,
    hostname: 'Cecilia',
    features: ['2 Baths', '2 Beds'],
    price: {
      original: '$500',
      sale: '$487',
    },
    tag: 'Plus',
  },
  {
    city: 'Lake Mauricio',
    country: 'Maldives',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/10.webp',
    rating: 3.84,
    ratingCount: 54,
    hostname: 'Tyra',
    features: ['3 Balcony', '5 Baths', '3 Beds'],
    price: {
      original: '$579',
      sale: '$313',
    },
    tag: 'Plus',
  },
  {
    city: 'West Vergie',
    country: 'Kiribati',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/13.webp',
    rating: 2.4,
    ratingCount: 168,
    hostname: 'Allison',
    features: ['3 Balcony', '2 Baths', '3 Beds'],
    price: {
      original: '$906',
      sale: '$391',
    },
    tag: 'Plus',
  },
  {
    city: 'South Jan',
    country: 'Malawi',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/8.webp',
    rating: 1.72,
    ratingCount: 75,
    hostname: 'Omer',
    features: ['5 Beds', '4 Baths'],
    price: {
      original: '$937',
      sale: '$264',
    },
    tag: 'Plus',
  },
  {
    city: 'Port Ivoryshire',
    country: "Cote d'Ivoire",
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/1.webp',
    rating: 3.96,
    ratingCount: 943,
    hostname: 'Demond',
    features: ['3 Baths', '5 Beds', '2 Balcony'],
    price: {
      original: '$713',
      sale: '$238',
    },
    tag: 'Superhost',
  },
  {
    city: 'Unafurt',
    country: 'Croatia',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/15.webp',
    rating: 1.16,
    ratingCount: 425,
    hostname: 'Lisandro',
    features: ['5 Beds', '4 Baths', '3 Balcony'],
    price: {
      original: '$637',
      sale: '$236',
    },
    tag: 'Superhost',
  },
  {
    city: 'Port Curtis',
    country: 'Cameroon',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/12.webp',
    rating: 2.74,
    ratingCount: 713,
    hostname: 'Tristin',
    features: ['2 Balcony', '1 Beds'],
    price: {
      original: '$788',
      sale: '$315',
    },
    tag: 'Plus',
  },
  {
    city: 'Lake Hermann',
    country: 'Lebanon',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/17.webp',
    rating: 1.96,
    ratingCount: 875,
    hostname: 'Brenna',
    features: ['2 Baths', '3 Balcony'],
    price: {
      original: '$786',
      sale: '$260',
    },
    tag: 'Plus',
  },
  {
    city: 'Lonieburgh',
    country: 'Namibia',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/9.webp',
    rating: 3.05,
    ratingCount: 129,
    hostname: 'Phoebe',
    features: ['1 Baths', '3 Beds', '2 Balcony'],
    price: {
      original: '$767',
      sale: '$276',
    },
    tag: 'Premium',
  },
  {
    city: 'Corkeryworth',
    country: 'Tonga',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/16.webp',
    rating: 1.59,
    ratingCount: 945,
    hostname: 'Yasmin',
    features: ['3 Baths', '3 Balcony'],
    price: {
      original: '$779',
      sale: '$396',
    },
    tag: 'Premium',
  },
  {
    city: 'New Manuel',
    country: 'Luxembourg',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/11.webp',
    rating: 3.16,
    ratingCount: 590,
    hostname: 'Abigayle',
    features: ['4 Baths', '2 Balcony', '5 Beds'],
    price: {
      original: '$875',
      sale: '$454',
    },
    tag: 'Superhost',
  },
  {
    city: 'Fort Jeraldberg',
    country: 'Ethiopia',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/14.webp',
    rating: 2.73,
    ratingCount: 714,
    hostname: 'Raphaelle',
    features: ['1 Beds', '5 Baths', '1 Balcony'],
    price: {
      original: '$547',
      sale: '$360',
    },
    tag: 'Plus',
  },
  {
    city: 'Lake Marisol',
    country: 'Pakistan',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/8.webp',
    rating: 4.03,
    ratingCount: 931,
    hostname: 'Harvey',
    features: ['3 Beds', '1 Balcony', '3 Baths'],
    price: {
      original: '$603',
      sale: '$385',
    },
    tag: 'Plus',
  },
  {
    city: 'Lake Ettie',
    country: 'Spain',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/4.webp',
    rating: 2.33,
    ratingCount: 646,
    hostname: 'Rozella',
    features: ['2 Baths', '3 Beds', '1 Balcony'],
    price: {
      original: '$909',
      sale: '$351',
    },
    tag: 'Superhost',
  },
  {
    city: 'Charlieside',
    country: 'Gambia',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/3.webp',
    rating: 4.28,
    ratingCount: 463,
    hostname: 'Alena',
    features: ['3 Balcony', '1 Baths'],
    price: {
      original: '$890',
      sale: '$473',
    },
    tag: 'Superhost',
  },
  {
    city: 'New Leilatown',
    country: 'Poland',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/11.webp',
    rating: 2.56,
    ratingCount: 932,
    hostname: 'Warren',
    features: ['2 Baths', '1 Balcony', '3 Beds'],
    price: {
      original: '$616',
      sale: '$227',
    },
    tag: 'Plus',
  },
  {
    city: 'Manchester',
    country: 'Palestine',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/16.webp',
    rating: 4.44,
    ratingCount: 87,
    hostname: 'Marshall',
    features: ['3 Baths', '2 Beds', '2 Balcony'],
    price: {
      original: '$680',
      sale: '$276',
    },
    tag: 'Superhost',
  },
  {
    city: 'Palo Alto',
    country: 'Guernsey',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/9.webp',
    rating: 3.87,
    ratingCount: 696,
    hostname: 'Isaac',
    features: ['4 Baths', '2 Beds'],
    price: {
      original: '$992',
      sale: '$385',
    },
    tag: 'Plus',
  },
  {
    city: 'Grimeschester',
    country: 'Saint Martin',
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/listings/6.webp',
    rating: 2.8,
    ratingCount: 275,
    hostname: 'Johnathon',
    features: ['1 Baths', '1 Balcony', '4 Beds'],
    price: {
      original: '$679',
      sale: '$313',
    },
    tag: 'Premium',
  },
];
